import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { 
    duration: { type: Number, default: 5000 },
    severity: { type: String, default: "info" }
  }

  connect() {
    console.log('[Toast] Connected, will dismiss in', this.durationValue, 'ms')
    
    // Animate in after a tiny delay to ensure CSS transition works
    requestAnimationFrame(() => {
      this.element.classList.remove('translate-x-full', 'opacity-0')
      this.element.classList.add('translate-x-0', 'opacity-100')
    })
    
    // Auto dismiss
    this.timeout = setTimeout(() => this.dismiss(), this.durationValue)
  }

  dismiss() {
    clearTimeout(this.timeout)
    
    // Animate out
    this.element.classList.remove('translate-x-0', 'opacity-100')
    this.element.classList.add('translate-x-full', 'opacity-0')
    
    // Remove after animation
    setTimeout(() => {
      this.element.remove()
    }, 300)
  }

  // Pause auto-dismiss on hover
  pause() {
    clearTimeout(this.timeout)
  }

  // Resume auto-dismiss on mouse leave
  resume() {
    this.timeout = setTimeout(() => this.dismiss(), this.durationValue)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
